import type { TFunction } from 'i18next';

import { ApiError } from './api/client.js';

/** A sentence for an API error in the user's language (api-spec §2 codes). */
export function errorMessage(error: unknown, t: TFunction): string {
  if (!(error instanceof ApiError)) return t('errors.INTERNAL');
  if (error.code === 'WEAK_PASSWORD') {
    const reason = (error.problem as { reason?: string }).reason;
    if (reason)
      return t(`errors.weakPassword.${reason}`, { defaultValue: t('errors.WEAK_PASSWORD') });
  }
  return t(`errors.${error.code}`, { defaultValue: t('errors.INTERNAL') });
}
